import { queryOptions } from '@tanstack/react-query'
import type { Group } from '@/types/groupTypes'
import type { UserData } from '@/types/userTypes'

// All Azure AD groups (SMS.* groups) — source for the picker's Groups segment.
export const groupsQueryOptions = () =>
  queryOptions({
    queryKey: ['getAllGroups'],
    queryFn: async (): Promise<Array<Group>> => {
      const response = await fetch('/api/listGroups')
      if (!response.ok) {
        throw new Error('Error fetching groups.')
      }
      const data = await response.json()
      return data.groups ?? []
    },
  })

// Members of one group. Used to resolve a group chip's count / textable / phone
// numbers when it is added to the composer, and to populate the new-chat dialog.
export const groupMembersQueryOptions = (groupId: string) =>
  queryOptions({
    queryKey: ['groupMembers', groupId],
    queryFn: async (): Promise<Array<UserData>> => {
      const response = await fetch(`/api/getGroupMembers?group=${groupId}`)
      if (!response.ok) {
        throw new Error('Failed to fetch group members')
      }
      const data = await response.json()
      return data.users ?? []
    },
    enabled: !!groupId,
    staleTime: 5 * 60 * 1000,
  })

// Directory search by name — source for the picker's People segment.
export const searchUsers = async (name: string): Promise<Array<UserData>> => {
  const response = await fetch(`/api/searchUser?name=${encodeURIComponent(name)}`)
  if (!response.ok) {
    throw new Error('Failed to search users')
  }
  const data = await response.json()
  return data.users ?? []
}
